import React, { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import axios from "axios";
const AcceptedRequest = ({
  name,
  desg,
  slot,
  id,
  status,
  payment,
  zIndex,
  shift,
}) => {
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  if (status !== "accepted" || payment === true) {
    return;
  }

  return (
    <>
      <div
        className={
          "absolute bg-white sent-item rounded my-4 p-2 z-" +
          zIndex +
          " right-" +
          shift
        }
      >
        <div className="absolute bottom-1 right-2 text-right">
          <p className="text-xs text-gray-400">Received 45 Min ago</p>
          <p className="text-xs text-gray-400">Accepted 15 Min ago</p>
        </div>
        <div className="sent-item-profile z">
          <img src={require("../../../images/photo.png")} alt="Profile" />
          <button className="cust-btn sent-view-btn">View Profile</button>
        </div>
        <div className="sent-item-info">
          <div className="px-3">
            <div>
              <div className="flex py-1 justify-between w-full">
                <div className="flex gap-x-2">
                  <div className="interviewer-logo">
                    <img
                      src={require("../../../images/iitd.png")}
                      alt="google"
                    />
                  </div>
                  <div>
                    <div>
                      <h4 className="text-2xl text-left font-medium leading-6">
                        {name}
                      </h4>
                      <p>{desg}</p>
                    </div>
                  </div>
                </div>
                <div className="flex gap-2">
                  <div className="flex justify-center h-10 text-blue-500 text-2xl">
                    <Button variant="contained">
                      <i className="fa-solid fa-link mr-1"></i> Resume
                    </Button>
                  </div>
                  <div className="flex justify-center border rounded-md p-2 w-10 h-10 text-blue-500 text-2xl hover:text-blue-600 cursor-pointer">
                    <i className="fa-solid fa-bookmark"></i>
                  </div>
                  <div className="flex justify-center border rounded-md p-2 w-10 h-10 text-green-500 text-2xl hover:text-green-600 cursor-pointer">
                    <i className="fa-solid fa-share"></i>
                  </div>
                </div>
              </div>
              <div className="grid grid-cols-4 text-center my-1 gap-x-4 mx-2">
                <div>
                  <p className="text-base text-gray-400">Profile</p>
                  <p className="text-lg">Data Science</p>
                </div>
                <div>
                  <p className="text-base text-gray-400">Price</p>
                  <p className="text-lg">INR 1200</p>
                </div>
                <div>
                  <p className="text-base text-gray-400">Session Duration</p>
                  <p className="text-lg">45 Min</p>
                </div>
                <div>
                  <p className="text-base text-gray-400">Interview Slot</p>
                  <p className="text-lg">{slot}</p>
                  <p className="text-lg">20 June, 2022</p>
                </div>
              </div>
              <div className="flex text-red-600 text-center">
                <div className="border rounded p-2 inline">
                  <div className="flex">
                    <img
                      src={require("../../../images/loading.gif")}
                      alt="loading"
                      style={{
                        width: "30px",
                        marginRight: "10px",
                      }}
                    />
                    <p>Waiting for John Doe to Pay & Confirm</p>
                  </div>
                </div>
                <div className="cancel-dropdown-cont">
                  <div className="relative w-8" id="cancel">
                    <div
                      className="cancel-dropdown flex"
                      style={{ height: "48px" }}
                    >
                      <i className="fa-solid fa-caret-right"></i>
                    </div>
                    <button
                      className="absolute hidden w-40 h-10 top-1 left-6 z-20 border border-red-600 rounded px-2 py-1 bg-red-600 text-white"
                      id="cancel-btn"
                      onClick={handleClickOpen}
                    >
                      Unaccept Request
                    </button>
                  </div>
                  <div>
                    {/* <Button
                      variant="outlined"
                      onClick={handleClickOpen}
                    >
                      Cancel
                    </Button> */}
                    <Dialog
                      open={open}
                      onClose={handleClose}
                      aria-labelledby="alert-dialog-title"
                      aria-describedby="alert-dialog-description"
                    >
                      <DialogTitle id="alert-dialog-title">
                        {"Use Google's location service?"}
                      </DialogTitle>
                      <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                          Let Google help apps determine location. This means
                          sending anonymous location data to Google, even when
                          no apps are running.
                        </DialogContentText>
                      </DialogContent>
                      <DialogActions>
                        <Button
                          onClick={() => {
                            axios.delete(
                              `${process.env.REACT_APP_SERVER_URL}/api/delete/${id}`
                            );
                          }}
                          autoFocus
                        >
                          YES
                        </Button>
                        <Button onClick={handleClose}>NO</Button>
                      </DialogActions>
                    </Dialog>
                  </div>
                </div>
                {/* <button
                  type="button"
                  className="cust-btn request-accepted-btn font-medium"
                ></button> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default AcceptedRequest;
